import getRepoNameFromUrl from "../../utils/Github"

function ProjectEarlier({name, hotlink, description, skill}) {
    const repoName = getRepoNameFromUrl(hotlink)
    return (
        <div className="past-project">
            <h2 className="year-header">{name}</h2>
            <a className="project-link" href={hotlink} target="_blank" rel="noopener noreferrer">
                {repoName ? `${repoName.username}/${repoName.repoName}` : hotlink}
            </a>
            <h3 className="detail-body">{description}</h3>
            <div className="chip-container">
                {skill.map((item) => (
                    <span key={item} className="chip-item">{item}</span>
                ))}
            </div>
            <br />
        </div>
    )
}

export default ProjectEarlier
